
<template>
    <div>
        <mars-view class="container home-bottom" @click.native="allClick"><top-bar title="优质问答" :bg-color="topBar.topBgColor" text-color="#000" :no-show-home="true"></top-bar><mars-view class="expertise-areas-space"></mars-view><mars-view v-if="isOpen" class="expertise-areas-mark" @click.native="foldMoreArea"></mars-view><mars-view class="expertise-areas" :class="{'expertise-areas-open': isOpen}" :style="'padding-top:' + (entireHeight + 15) + 'px'"><template v-if="isOpen"><mars-view v-for="item, index in areas" :key="index" class="area-item" :class="{'area-item-current': currentDomains === item.name}" @click.native="clickAreaItem(item, index)"><mars-view class="icon" :style="{backgroundImage: 'url(' + item.icon + ')'}"></mars-view><mars-view class="name">
                    {{ item.name === 'all' ? '全部领域' : item.name }}
                </mars-view></mars-view></template><mars-scroll-view v-else scroll-x :scroll-into-view="currentDomainScroll" scroll-with-animation><mars-view class="area-item-box"><mars-view v-for="item, index in areas" :id="'area-item' + index" :key="index" class="area-item" :class="{'area-item-current': currentDomains === item.name}" @click.native="clickAreaItem(item, index)"><mars-view class="icon" :style="{backgroundImage: 'url(' + item.icon + ')'}"></mars-view><mars-view class="name">
                        {{ item.name === 'all' ? '全部领域' : item.name }}
                    </mars-view></mars-view><mars-view class="area-item-space"></mars-view></mars-view></mars-scroll-view><mars-view v-if="!isOpen" class="open-btn" :style="'top:' + (entireHeight + 15) + 'px'"><mars-view class="shadow"></mars-view><mars-view class="open-btn-text" @click.native="openMoreArea('')"><mars-view>展</mars-view><mars-view>开</mars-view><mars-view class="home-top-city-icon icon iconfont"></mars-view></mars-view></mars-view><mars-view v-if="isOpen" class="fold-btn" @click.native="foldMoreArea"><mars-view class="line"></mars-view><mars-view class="fold-btn-text icon iconfont">
                点击收起 
            </mars-view></mars-view></mars-view><mars-view class="home-content"><mars-view class="home-content-list"><mars-view v-if="list && list.length" class="home-carefully"><mars-view class="home-carefully-top"><mars-view class="home-carefully-top-title">
                        {{ currentDomains === 'all' ? '全部领域' : (currentDomains || '全部领域') }}
                    </mars-view><mars-view class="home-carefully-top-more icon iconfont" @click.native="showSelectPopup">
                        {{ sortName }} <mars-text class="all-icon"></mars-text></mars-view></mars-view><mars-view class="curefully-question-list"><mars-view v-for="item,index in list" :key="index" class="curefully-question-list-item" :class="'curefully-question-list-item-' + item.pageNum" data-area="flwd_show" data-serverid="16139" :data-extswan="{
                            index: index,
                            uk: item.expertInfo.uk,
                        }" :data-exts="JSON.stringify({
                            index: index,
                            uk: item.expertInfo.uk,
                        })" @click.native="jumpQuestionDetail(item, index + 1)"><question-card :question="item" slot-click="flwd_click" slot-lawyer-click="flwd_lawyer_card_click" slot-lawyer-consult-click="flwd_consult_click" fr="flwd_list_lawyer_card"></question-card></mars-view></mars-view></mars-view><mars-view v-if="noMoreResult" class="info_top l-text-center c-font-normal c-color-gray c-gap-bottom-large">
                已显示全部内容
            </mars-view><mars-view v-if="bottomLoading" class="l-span-center bottom-loading-icon-far"><mars-image class="bottom-loading-icon" :lazy-load="true" src="https://lvlin-base.cdn.bcebos.com/law/pages/new-home/Vector.png"></mars-image></mars-view></mars-view><template v-if="topLoading"><c-loading class="loading"></c-loading></template></mars-view><mars-view class="home-bottom"></mars-view><base-popup title="选择排序类型" :show="isShowSelect" :close-on-click-overlay="true" @close="showSelectPopup"><mars-view class="sort-box" @click.native.stop><mars-view class="sort-item" :class="{'sort-item-active': sortType === 0}" @click.native="selectorChange(0)">
                智能排序
            </mars-view><mars-view class="sort-item" :class="{'sort-item-active': sortType === 1}" @click.native="selectorChange(1)">
                热门排序
            </mars-view><mars-view class="sort-item" :class="{'sort-item-active': sortType === 2}" @click.native="selectorChange(2)">
                最新排序
            </mars-view></mars-view></base-popup></mars-view>
    </div>
</template>

<script>
/* globals getApp swan */
import Topbar from "../../components/common/topbar.vue";
import { getData } from '../../static/utils/request.js';
import { reqPathTo } from '../../static/utils/env.js';
import { ubcClickInit } from '../../static/utils/ubcMethods.js';
import Loading from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Loading/Loading.vue";
import { setPageInfoMenu } from '../../static/utils/setPageInfoMenu';
import { act } from '../../static/utils/navigate';
import log from '../../static/utils/ubcLog';
import { consultPageChange } from '../../static/utils/consultEvents.js';
import { domains } from './config';
import questionCard from "../../components/home/questionCard.vue";
import basePopup from "../../components/common/basePopup.vue";
import { inSightObservers } from '../../common/js/repeatExposureLog.js';
export default {
  components: {
    'top-bar': Topbar,
    'c-loading': Loading,
    'question-card': questionCard,
    'base-popup': basePopup
  },
  methods: {
    showSelectPopup() {
      this.isShowSelect = !this.isShowSelect;
    },
    // 所有点击
    allClick() {
      log.send && log.send({
        serverId: 16205,
        area: 'qa-click',
        action: 'click',
        expertArea: this.currentDomains || ''
      });
    },
    // 排序规则改变
    selectorChange(value) {
      if (this.menuTypeArr[value].id === this.sortType) {
        return;
      }
      this.sortType = this.menuTypeArr[value].id;
      this.sortName = this.menuTypeArr[value].val;
      this.changeMenuType(this.sortType);
      this.showSelectPopup();
    },
    // 点击领域
    clickAreaItem(item = {}, index) {
      if (this.requestLock) {
        return;
      }
      let {
        value,
        name
      } = item;
      if (this.isDefaultOpen) {
        log.send && log.send({
          serverId: 16205,
          area: 'qa-open-click',
          action: 'click',
          expertArea: name || ''
        });
      } else {
        log.send && log.send({
          serverId: 16205,
          area: 'expert-area',
          action: 'click',
          expertArea: name || ''
        });
      }
      this.isOpen = false;
      // 领域名称
      this.currentDomains = name;
      // 领域id
      this.fieldId = value;
      this.currentDomainScroll = 'area-item' + index;
      getApp().globalData.currentDomains = name;
      getApp().globalData.currentDomainsValue = value;
      this.setRequestLock(true);
      this.initReqData();
      this.updateExpertList();
    },
    // 跳转问答详情
    jumpQuestionDetail(data) {
      let {
        qid
      } = data || {};
      log.send && log.send({
        serverId: 16205,
        area: 'content-click',
        action: 'click',
        uk: data.expertInfo.uk
      });
      if (!qid) {
        return;
      }
      act({
        target: `/question/${qid}?fr=content-list`,
        type: 'url'
      });
    },
    // 跳转律师详情
    jumpLawyer(lawyer) {
      act({
        target: lawyer.target,
        type: 'url'
      });
      this.allClick();
    },
    // 跳转律师咨询
    jumpLawyerConsult({
      uk,
      qualificationId: qcNo
    }) {
      this.allClick();
      log.send && log.send({
        serverId: 16205,
        area: 'lawyer-card-btn',
        action: 'click',
        uk
      });
      consultPageChange(qcNo);
    },
    // 打开领域选择
    openMoreArea(isDefaultOpen) {
      this.isOpen = true;
      if (isDefaultOpen) {
        this.isDefaultOpen = true;
        log.send && log.send({
          serverId: 16205,
          area: 'qa-open-show',
          action: 'show'
        });
        return;
      }
      log.send && log.send({
        serverId: 16205,
        area: 'open-click',
        action: 'click'
      });
    },
    // 关闭领域选择
    foldMoreArea() {
      this.isOpen = false;
      this.isDefaultOpen = false;
      log.send && log.send({
        serverId: 16205,
        area: 'close-click',
        action: 'click'
      });
    },
    // 初始化数据
    initReqData() {
      this.questionListTop = null;
      this.list = [];
      this.pn = 1;
      this.noMoreResult = false;
      this.bottomLoading = false;
      this.topLoading = true;
    },
    changeMenuType(idx) {
      if (this.requestLock) {
        return;
      }
      this.setRequestLock(true);
      this.sortType = idx;
      this.initReqData();
      this.updateExpertList();
      ubcClickInit({
        page: 'contentList',
        value: 'contentList-type-sort',
        ext: {
          sortType: idx
        }
      });
    },
    // 初始化
    init(ctx) {
      this.setRequestLock(true);
      const area = (ctx.tabName === '全部领域' ? 'all' : ctx.tabName) || getApp().globalData.currentDomains;
      const value = ctx.tabId || getApp().globalData.currentDomainsValue;
      this.currentDomains = area || 'all';
      if (value) {
        this.fieldId = value;
      }
      const data = {
        // 排序类型，1智能排序，2热门排序，3最新排序
        sortType: this.sortType,
        // 领域菜单-对应value,默认全部领域 999
        tabId: this.fieldId
      };
      const getFristDataUrl = reqPathTo('special_qa_page', {}, '', 'falv');
      getData({
        url: getFristDataUrl,
        data,
        loginNeeded: false
      }).then((data = {}) => {
        this.result = data;
        let {
          qaList = [],
          tags = [],
          types = []
        } = data;
        qaList = qaList.map(item => {
          item.pageNum = this.pn;
          return item;
        });
        this.list = qaList;
        // 领域列表-信息处理
        tags.forEach(item => {
          if (item.text === '全部领域') {
            item.name = 'all';
          } else {
            item.name = item.text;
          }
        });
        this.areas = domains;
        // 排序列表-数据处理
        let typesArr = [];
        types.forEach(item => {
          let info = {};
          info.val = item.text;
          info.id = item.value;
          typesArr.push(info);
        });
        // 排序列表
        this.menuTypeArr = typesArr;
        this.pn += 1;
        this.setRequestLock(false);
        this.topLoading = false;
        const isShowDomainSort = this.$api.getStorageSync('is_show_domain_sort');
        if (!isShowDomainSort) {
          this.openMoreArea('isDefaultOpen');
          this.$api.setStorageSync('is_show_domain_sort', 'show');
        }
        this.$mpUpdated(() => {
          let observerTimeout = setTimeout(() => {
            inSightObservers('.curefully-question-list-item-' + (this.pn - 1 || 1), '', {}, [], true, true);
            clearTimeout(observerTimeout);
            observerTimeout = null;
          }, 500);
        });
      });
    },
    // 下拉加载或者刷新
    updateExpertList() {
      const getFristDataUrl = reqPathTo('special_qa_list', {}, '', 'falv');
      const data = {
        sortType: this.sortType,
        pn: this.pn,
        rn: 10,
        tabId: this.fieldId
      };
      return this.$api.request({
        url: getFristDataUrl,
        data: data
      }).then(res => {
        try {
          let list = res.data.data.qaList || [];
          list = list.map(item => {
            item.pageNum = this.pn;
            return item;
          });
          let hasMore = res.data.data.has_more;
          this.topLoading = false;
          // 存在数据过滤的问题，不能使用length来判断
          if (!hasMore) {
            this.noMoreResult = this.pn !== 1;
            this.bottomLoading = false;
          } else {
            this.pn += 1;
          }
          this.list = [...this.list, ...list];
        } catch (e) {}
        this.setRequestLock(false);
        this.$mpUpdated(() => {
          let observerTimeout = setTimeout(() => {
            inSightObservers('.curefully-question-list-item-' + (this.pn - 1 || 1), '', {}, [], true, true);
            clearTimeout(observerTimeout);
            observerTimeout = null;
          }, 500);
        });
      });
    },
    // 无限下拉异步请求律师
    getAsyncExperts() {
      if (this.requestLock) {
        return;
      }
      this.setRequestLock(true);
      this.bottomLoading = true;
      this.updateExpertList();
    },
    // @description 添加统一的请求锁
    // init                初始化
    // filterChangeFn      参数变化              topLoading 加载态
    // getAsyncExperts     无限下拉异步请求律师    bottomLoading 下面的加载
    setRequestLock(bool = false) {
      if (bool !== this.requestLock) {
        this.requestLock = bool;
      }
    },
    onReachBottom() {
      if (this.noMoreResult) {
        return;
      }
      this.getAsyncExperts();
    }
  },
  data() {
    return {
      topLoading: true,
      noMoreResult: false,
      bottomLoading: false,
      tagsFixedFlag: false,
      // 智能排序 0  热门 1 最新 2
      sortType: 0,
      sortName: '智能排序',
      // 领域id-默认 全部领域 999
      fieldId: 999,
      statBarHeight: 20,
      navBarHeight: 44,
      entireHeight: 64,
      currentDomains: 'all',
      menuTypeArr: [],
      pn: 1,
      rn: 10,
      result: [],
      list: [],
      curTagIdx: 0,
      topBar: {
        topBgColor: 'transparent'
      },
      imgsrc: 'https://ss2.baidu.com/6ONYsjip0QIZ8tyhnq/it/u=2916203555,3196138030&' + 'fm=179&app=35&f=GIF?w=300&h=150&s=69C03262DFE7BB510C50D41B0000E0C1',
      areas: [],
      // 筛选列表数据
      currentDomainScroll: 'area-item0',
      questionListTop: null,
      // 第一个问答的数据
      isOpen: false,
      // 是否打开状态
      styleType: false,
      // 顶部背景颜色
      isShowSelect: false,
      isDefaultOpen: false // 是否默认打开
    };
  },

  mounted() {
    /* globals Page, getCurrentPages */
    // 设置bar高度
    let sys = getApp().globalData.system;
    this.statBarHeight = sys.statusBarHeight;
    this.navBarHeight = sys.navigationBarHeight;
    this.entireHeight = this.statBarHeight + this.navBarHeight;
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  created() {
    (function (ctx) {
      this.init(ctx);
      log.addKey && log.addKey({
        ...ctx,
        page: 'selectedList'
      });
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      setPageInfoMenu({
        title: '律临法律服务_精选问答'
      });
      log.send && log.send({
        serverId: 16205,
        area: 'qa-show',
        action: 'show'
      });
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.expertise-areas,
.authority-lawyer {
  padding: 0 0.11rem;
}
.expertise-areas-space {
  height: 0.69rem;
  padding-top: 0.15rem;
  padding-bottom: 0.15rem;
}
.expertise-areas-mark {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.3);
}
.home-top-city-icon {
  font-size: 0.14rem;
}
.expertise-areas {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  position: relative;
  box-sizing: border-box;
  padding-top: 15px;
  padding-bottom: 0.14rem;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 180;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/new-home/home-top-bgs.png');
  background-repeat: no-repeat;
  background-size: 100% 277px;
}
.expertise-areas .area-item-box {
  width: auto;
  display: flex;
  flex-wrap: nowrap;
}
.expertise-areas .area-item {
  min-width: 0.72rem;
  height: 0.78rem;
  padding: 0.09rem 0.06rem 0.06rem;
  box-sizing: border-box;
  margin-right: 0.08rem;
  background: #fff;
  border-radius: 0.09rem;
  border: 0.33px solid rgba(132, 134, 145, 0.1);
}
.expertise-areas .area-item .icon {
  height: 0.32rem;
  width: 0.32rem;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.expertise-areas .area-item .name {
  font-size: 0.14rem;
  color: #50525c;
  text-align: center;
  line-height: 0.14rem;
  font-weight: 400;
  margin-top: 0.09rem;
  white-space: nowrap;
}
.expertise-areas .area-item-space {
  padding-left: 0.2rem;
  height: 0.69rem;
}
.expertise-areas .area-item-current {
  border: 1px solid rgba(0, 85, 255, 0.25);
}
.expertise-areas .area-item-current .name {
  font-family: PingFangSC-Medium;
  color: #1e1f24;
  font-weight: bold;
  font-size: 0.14rem;
}
.expertise-areas .open-btn {
  width: 0.55rem;
  height: 0.78rem;
  position: absolute;
  top: 0.15rem;
  right: 0;
  border-radius: 0.09rem;
  overflow: hidden;
}
.expertise-areas .open-btn .shadow {
  width: 20px;
  height: 20px;
  background: transparent;
  box-shadow: -10px 0px 20px rgba(0, 0, 0, 0.3);
  z-index: 9;
  position: absolute;
  right: 10%;
  top: 36%;
}
.expertise-areas .open-btn .open-btn-text {
  display: flex;
  flex-direction: column;
  width: 0.36rem;
  height: 0.89rem;
  margin-top: -0.1rem;
  padding-top: 0.2rem;
  background: linear-gradient(180deg, #f0f6ff 0%, #f9fafc 100%);
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  line-height: 0.21rem;
  color: #1e1f24;
  text-align: center;
  position: absolute;
  right: 0;
  z-index: 10;
}
.expertise-areas .fold-btn {
  position: absolute;
  width: 94.72vw;
  bottom: 0;
  padding-bottom: 0.17rem;
}
.expertise-areas .fold-btn .fold-btn-text {
  font-family: PingFang SC;
  font-size: 0.14rem;
  color: #1e1f24;
  text-align: center;
}
.expertise-areas-open {
  flex-wrap: wrap;
  padding-bottom: 0.48rem;
  position: fixed;
  top: 0;
  left: 0;
  border-radius: 0 0 0.21rem 0.21rem;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/new-home/home-top-bgs.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.expertise-areas-open .area-item {
  width: 0.72rem;
  margin-right: 0.08rem;
  margin-bottom: 0.08rem;
}
.expertise-areas-open .area-item:nth-child(5n) {
  margin-right: 0;
}
.home-content {
  box-sizing: border-box;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  position: relative;
  z-index: 10;
}
.home-content .home-content-list {
  width: 100%;
  background: #f5f6f9;
  display: block;
}
.home-bottom {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.bottom-loading-icon-far {
  background: #fff;
}
.l-span-center {
  padding: 15px 0 15px;
}
.bottom-loading-icon {
  width: 20px;
  height: 20px;
  transform-origin: center center;
  animation: circles 1.5s linear infinite;
}
@keyframes circles {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading {
  position: relative;
  top: 140px;
}
.home-carefully {
  width: 100%;
  height: auto;
  background: #fff;
  padding: 0.22rem 0.17rem 0.15rem;
  box-sizing: border-box;
  margin-top: 0.1rem;
}
.home-carefully-top {
  display: flex;
  justify-content: space-between;
  padding-top: 0.04rem;
  padding-bottom: 0.04rem;
}
.home-carefully-top-title {
  font-family: PingFangSC-Medium;
  font-weight: bold;
  font-size: 0.18rem;
  color: #1f1f1f;
  line-height: 1;
  display: flex;
  align-items: flex-end;
}
.home-carefully-top-sub-title {
  font-family: PingFangSC-Regular;
  font-size: 0.12rem;
  color: #858585;
  line-height: 1;
  margin-left: 0.05rem;
}
.home-carefully-top-more {
  font-family: PingFangSC-Regular;
  font-size: 0.15rem;
  color: #848691;
  text-align: right;
  line-height: 0.15rem;
  vertical-align: bottom;
}
.home-carefully-top-more .all-icon {
  font-size: 0.15rem;
}
.sort-box {
  width: 100%;
}
.sort-box .sort-item {
  padding: 0.22rem 0.17rem 0.19rem;
  color: #1e1f24;
  font-size: 0.16rem;
  line-height: 1;
}
.sort-box .sort-item-active {
  color: #05f;
  position: relative;
}
.sort-box .sort-item-active:after {
  content: '';
  width: 0.16rem;
  height: 0.11rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/new-home/select-icon.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 50%;
  right: 0.17rem;
  transform: translateY(-50%);
}

</style>
